export const ORIGIN = 'https://www.figma.com';
